export enum Channel {
  Whatsapp = 'Whatsapp',
  RCS = 'RCS',
  ViberBusiness = 'ViberBusiness',
  KakaoTalk = 'KakaoTalk',
}
